import React, { useEffect } from 'react';
import { Button } from '@material-ui/core';
import './style.scss';
import { useHistory } from 'react-router-dom';
import ContactMenuItem from 'app/shared/components/mobile/contact-menu-item/contact-menu-item';
import Avatar from 'app/shared/components/mobile/avatar-with-badge/avatar';
import { useDispatch, useSelector } from 'react-redux';
import { getDataViewRules } from 'app/modules/rules/service/store/selectors';
import { View } from 'app/modules/rules/domain/View';
import { RulesContext } from 'app/modules/rules/domain/RulesContext';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';
import { getDataView } from 'app/modules/rules/service/rulesService';
import ConfComp from 'app/shared/components/common/conf-component';
import { IRootState } from 'app/shared/reducers';

const contractRescind = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const viewConf = useSelector(getDataViewRules(View.MOBILE_RESCIND_CONTRACT));
    const subscriptionSelected = useSelector<IRootState>(state => state.contract.subscriptionModel.subscriptionSelected) as any;

    const rulesContext: RulesContext = {
        key: RulesKeys.GET_VIEW_DATA_CONFIGURATION,
        entryDataRules: { view: View.MOBILE_RESCIND_CONTRACT,productCode : subscriptionSelected.productCode},
      };

      useEffect(() => {
        dispatch(getDataView(rulesContext));

      }, []);

    return (
        <>
        {viewConf &&

            <ConfComp
                  code= {'MOBILE_RESCIND_CHOICE'}
                  listCode= {viewConf.componentDataList}

            />}
      </>
    );

};

export default contractRescind;
